import { Injectable } from '@angular/core';
import type { Observable } from 'rxjs';

import { BaseHttpService } from '@common/services/REST/base.http.service';
import type { Template, TemplateUpdateRequest } from '@common/types/template.type';

@Injectable({
    providedIn: 'root',
})
export class TemplatesHttpService extends BaseHttpService {
    public getTemplate(templateId: string | number): Observable<Template> {
        return this.http.get<Template>(this.formatApiUrl(`templates/${templateId}`));
    }

    public getAdminTemplate(templateId: string | number): Observable<Template> {
        const url = this.formatApiUrl(`templates/${templateId}`);
        return this.http.get<Template>(`/admin${url}`);
    }

    public updateAdminTemplate(data: TemplateUpdateRequest, templateId: number | string): Observable<Template> {
        const url = this.formatApiUrl(`templates/${templateId}`);
        return this.http.put<Template>(`/admin${url}`, data);
    }
}
